import { Component, OnInit } from '@angular/core';
import { BgIndexPackageService } from '@app/services/index-mapping.service';
import * as feather from 'feather-icons';
@Component({
  standalone: false,
  selector: 'app-bg-index-mapping',
  templateUrl: './bg-index-mapping.component.html',
  styleUrls: ['./bg-index-mapping.component.css'],
})
export class BgIndexMappingComponent implements OnInit {
  bgIndexMappings: any[] = [];
  paginatedMappings: any[] = [];
  currentPage = 1;
  itemsPerPage = 25;
  searchTerm = '';
  isLoading = false;
  isAdding = false;
  popup = false
  newMapping = {
    bg_index_code: '',
    package_id: '',
    flow_id: '',
    package_description: '',
    position_title: '',
    created_by: '',
    modified_by: '',
  };
  bgAdd: any
  errorInput: string
  delete = false
  mappingSelected: any
  selectedMapping: { bg_index_code: any; };
  isEditing = false;
  editFields: string[] = ['bg_index_code','flow_id','position_title','package_id'];
  columns: { key: string, label: string, sortable?: boolean }[] = [
    { key: 'id', label: 'ID', sortable: false },
    { key: 'bg_index_code', label: 'BG Index Code', sortable: false },
    { key: 'package_id', label: 'Package ID', sortable: false },
    { key: 'flow_id', label: 'Flow ID', sortable: false },
    { key: 'created_by', label: 'Created By', sortable: false },
    { key: 'modified_by', label: 'Modified By', sortable: false },
    { key: 'package_description', label: 'Package Description', sortable: false },
    { key: 'position_title', label: 'Position Title', sortable: false },
    { key: 'actions', label: 'Actions' }
  ];

  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  sortTable(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.bgIndexMappings.sort((a, b) => {
      const valueA = a[column] || '';
      const valueB = b[column] || '';
      return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });

    this.updatePaginatedMappings();
  }


  constructor(private bgIndexPackageService: BgIndexPackageService) { }

  ngOnInit() {
    this.loadMappings();
    this.bgAdd = {
      bgHeader: ['BG Index Code', 'Flow ID', 'Position Id', 'Position Title'],
      fieldKeys: ['bg_index_code', 'flow_id', 'package_id', 'position_title', 'created_by', 'modified_by', 'package_description',]
    };
  }

   ngAfterViewInit() {
      feather.replace();
    }

  loadMappings() {
    this.isLoading = true;
    this.bgIndexPackageService.getIndex().subscribe(
      (data) => {
        this.bgIndexMappings = data.map((item) => ({ ...item, isEditing: false }));
        // console.log(this.bgIndexMappings);
        this.updatePaginatedMappings();
      },
      (error) => {
        console.error('Error fetching BG index mappings', error);
      },
      () => {
        this.isLoading = false;
      },
    );
  }

  updatePaginatedMappings() {
    const filteredMappings = this.bgIndexMappings.filter(
      (mapping) =>
        mapping.bg_index_code.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        mapping.flow_id.toString().includes(this.searchTerm),
    );
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    this.paginatedMappings = filteredMappings.slice(startIndex, startIndex + this.itemsPerPage);
  }

  onSearchChange(searchValue: string) {
    this.searchTerm = searchValue;
    this.currentPage = 1;
    this.updatePaginatedMappings();
  }

  nextPage() {
    if (this.currentPage * this.itemsPerPage < this.bgIndexMappings.length) {
      this.currentPage++;
      this.updatePaginatedMappings();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedMappings();
    }
  }

  goToFirstPage(){
    if (this.currentPage > 1) {
      this.currentPage = 1
      this.updatePaginatedMappings();
    }
  }

  goToLastPage(){
    if (this.currentPage < this.totalPages) {
      this.currentPage = this.totalPages
      this.updatePaginatedMappings();
    }
  }

  get totalPages() {
    const filteredCount = this.bgIndexMappings.filter(
      (mapping) =>
        mapping.bg_index_code.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        mapping.flow_id.toString().includes(this.searchTerm),
    ).length;

    return Math.ceil(filteredCount / this.itemsPerPage);
  }

  editMapping(mapping: any) {
    this.selectedMapping = { ...mapping };
    this.isEditing = true;
  }
  getDisplayKey(key: string): string {
    return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }
  saveMapping() {
    if (!this.selectedMapping) {
      console.error('No mapping selected for saving.');
      return;
    }

    this.isLoading = true;

    const { bg_index_code } = this.selectedMapping;
    if (!bg_index_code) {
      console.error('bg_index_code is missing in selectedMapping.');
      this.isLoading = false;
      return;
    }

    this.bgIndexPackageService.updateIndex(bg_index_code, this.selectedMapping).subscribe(
      (response) => {
        console.log('Record updated successfully', response);
        const index = this.paginatedMappings.findIndex(mapping => mapping.bg_index_code === bg_index_code);
        if (index !== -1) {
          this.paginatedMappings[index] = { ...this.selectedMapping };
        }
        this.isEditing = false;
      },
      (error) => {
        console.error('Error updating record', error);
      },
      () => {
        this.isLoading = false;
      }
    );
  }


  cancelEdit(_mapping: any) {
    this.isEditing = false;
  }

  showAddMappingForm() {
    this.popup = true
    this.isAdding = true;
    this.newMapping = {
      bg_index_code: '',
      package_id: '',
      flow_id: '',
      package_description: '',
      position_title: '',
      created_by: '',
      modified_by: '',
    };
  }

  changingData(_event: Event) {
    if (this.newMapping.bg_index_code.length > 0 && this.newMapping.flow_id.length > 0 && this.newMapping.package_id.length > 0 && this.newMapping.created_by.length > 0) {
      this.errorInput = ""
    }
  }

  createMapping() {
    console.log('this.newMapping', this.newMapping);
    if (this.newMapping.bg_index_code.length > 0 && this.newMapping.flow_id.length > 0 && this.newMapping.position_title.length > 0) {
      this.errorInput = ""
      this.isLoading = true;
      this.bgIndexPackageService.createMapping(this.newMapping).subscribe(
        (response) => {
          console.log('Mapping created successfully', response);
          this.isAdding = false;
          this.popup = false
          this.loadMappings();
        },
        (error) => {
          console.error('Error creating mapping', error);
        },
        () => {
          this.isLoading = false;
        },
      );
    } else {
      this.errorInput = "To save the New BG index, please enter all data."
    }

  }
  deleteMapping(mapping: any) {
    this.popup = true;
    this.delete = true
    this.mappingSelected = mapping
  }
  cancelDelete() {
    this.popup = false;
    this.delete = false
  }
  confirmDelete() {
    console.log('mapping', this.mappingSelected);
    this.bgIndexPackageService.delete(this.mappingSelected).subscribe(
      (response) => {
        console.log(response);
        this.popup = false;
        this.delete = false
        this.loadMappings();
      }, (error) => {
        console.error('Error updating record', error);
      },
    )
  }

  cancelAdd() {
    this.isAdding = false;
    this.popup = false
    this.errorInput = ""
  }
}
